import React from "react";
import { ArrowRight, Phone, Check, Star } from "lucide-react";
import { Button } from "./ui/button";
import { company } from "../mock";

const Hero = () => {
  return (
    <section id="home" className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden">
      <div className="absolute inset-0 bg-grid pointer-events-none" />
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-yellow-200/40 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-40 -left-20 w-72 h-72 bg-yellow-100/60 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="fade-in-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-yellow-100 text-slate-800 text-xs font-semibold mb-6 border border-yellow-200">
              <span className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse" />
              {company.experience} in latex spuitwerk
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.05] text-balance">
              Vakkundig{" "}
              <span className="relative inline-block">
                <span className="relative z-10">latex spuiten</span>
                <span className="absolute left-0 right-0 bottom-1 h-3 bg-yellow-300/70 -z-0 rounded" />
              </span>
              <br />
              voor een strak resultaat.
            </h1>

            <p className="mt-6 text-lg text-slate-600 max-w-xl leading-relaxed">
              Wanden, plafonds en kozijnen netjes afgespoten – sneller, mooier en
              voordeliger dan traditioneel schilderen. Voor particulieren en bedrijven
              in heel Nederland.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Button
                asChild
                size="lg"
                className="bg-yellow-400 hover:bg-yellow-500 text-slate-900 font-semibold h-12 px-6 shadow-sm"
              >
                <a href="#contact" className="flex items-center gap-2">
                  Vraag vrijblijvend offerte aan
                  <ArrowRight className="w-4 h-4" />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                size="lg"
                className="h-12 px-6 border-slate-300 hover:bg-slate-50 font-semibold"
              >
                <a href={`tel:${company.phoneRaw}`} className="flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  Bel {company.phone}
                </a>
              </Button>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3">
              {[
                "Vanaf \u20AC 3,- per m\u00B2",
                "Snel én strak",
                "Gratis offerte",
              ].map((t) => (
                <div key={t} className="flex items-center gap-2 text-sm text-slate-700">
                  <span className="w-5 h-5 rounded-full bg-yellow-400 flex items-center justify-center">
                    <Check className="w-3 h-3 text-slate-900" strokeWidth={3} />
                  </span>
                  <span className="font-medium">{t}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative fade-in-up" style={{ animationDelay: "0.15s" }}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-slate-200">
              <img
                src="https://images.unsplash.com/photo-1745665777586-09381ba528d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxwYWludGVyJTIwc3ByYXlpbmd8ZW58MHx8fHwxNzgxNzk2NjA4fDA&ixlib=rb-4.1.0&q=85"
                alt="Vakman bezig met latex spuiten"
                className="w-full h-[460px] lg:h-[560px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent" />
            </div>

            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-5 ring-1 ring-slate-100 hidden sm:block">
              <div className="flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <div className="mt-2 text-2xl font-bold text-slate-900">5,0 / 5,0</div>
              <div className="text-xs text-slate-500">Beoordeeld door klanten</div>
            </div>

            <div className="absolute -top-6 -right-6 bg-yellow-400 text-slate-900 rounded-2xl shadow-xl p-5 hidden sm:block">
              <div className="text-3xl font-extrabold">25+</div>
              <div className="text-xs font-semibold uppercase tracking-wide">jaar ervaring</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
